var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return (item.to)?_c('v-breadcrumbs-item',{attrs:{"exact":"","to":item.to}},[_vm._v(" "+_vm._s(item.text)+" ")]):_c('v-breadcrumbs-item',{staticStyle:{"color":"#9C9C9C"}},[_vm._v(" "+_vm._s(item.text)+" ")])}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }